import john_doe from '../assets/testimonials/photo-1542909168-82c3e7fdca5c.avif';
import jane_smith from '../assets/testimonials/photo-1554151228-14d9def656e4.avif';
import sam_johnson from '../assets/testimonials/photo-1555952517-2e8e729e0b44.avif';
import emily_white from '../assets/testimonials/photo-1438761681033-6461ffad8d80.avif';
import alex_turnner from '../assets/testimonials/photo-1601412436009-d964bd02edbc.avif';
import olivia_brown from '../assets/testimonials/premium_photo-1664203067979-47448934fd97.avif';
import chris_miller from '../assets/testimonials/premium_photo-1682965699797-a2bd37f62b45.avif';


export const testimonials = [
    {
        name: "John Doe",
        img_url: john_doe,
        address: "123 Main Street, Cityville",
        rating: 5,
        message: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin eget justo sit amet risus finibus gravida.",
    },
    {
        name: "Jane Smith",
        img_url: jane_smith,
        address: "456 Oak Avenue, Townsville",
        rating: 4,
        message: "Sed quis metus ut odio dictum cursus vel ac leo. Suspendisse ac massa id leo tristique pharetra.",
    },
    {
        name: "Sam Johnson",
        img_url: sam_johnson,
        address: "789 Pine Road, Villageland",
        rating: 5,
        message: "Vivamus non arcu at elit tincidunt varius a et erat. Sed nec mi vel felis commodo mattis.",
    },
    {
        name: "Emily White",
        img_url: emily_white,
        address: "101 Cedar Street, Hamletville",
        rating: 4,
        message: "Curabitur ac mi vel tellus luctus ultrices. Nullam id nisi a lectus ullamcorper accumsan.",
    },
    {
        name: "Alex Turner",
        img_url: alex_turnner,
        address: "202 Elm Lane, Boroughburg",
        rating: 5,
        message: "Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.",
    },
    {
        name: "Olivia Brown",
        img_url: olivia_brown,
        address: "303 Walnut Drive, Township",
        rating: 4,
        message: "Aenean rhoncus justo at tortor semper, et accumsan sapien bibendum. Sed ullamcorper turpis nec sapien auctor, non fringilla odio rhoncus.",
    },
    {
        name: "Chris Miller",
        img_url: chris_miller,
        address: "404 Birch Street, District",
        rating: 5,
        message: "In hac habitasse platea dictumst. Quisque ut ultrices odio, nec varius purus. Nunc at massa eget urna vestibulum hendrerit.",
    },
];
